/* tslint:disable */
/* eslint-disable */
/**
 * RentalWorksStorefront API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface FwStandardBusinessLogicFwBusinessLogic {
    'AuditNote'?: string | null;
    'RecordTitle'?: string | null;
    'UrlIdentifier'?: any | null;
    '_Fields'?: Array<FwStandardBusinessLogicFwBusinessLogicFieldDefinition> | null;
    '_Custom'?: Array<FwStandardDataFwCustomValue> | null;
    '_DefaultFieldAttributes'?: Array<FwStandardDataFwDefaultAttribute> | null;
    '_Original'?: FwStandardBusinessLogicFwBusinessLogic;
    '_Translation'?: Array<FwStandardDataFwTranslatedValue> | null;
    '_HasImport'?: boolean;
    '_HasDocuments'?: boolean;
    'CreatedByUserId'?: string | null;
    'CreatedByUserName'?: string | null;
    'CreatedDateTime'?: string | null;
    'ModifiedByUserId'?: string | null;
    'ModifiedByUserName'?: string | null;
    'ModifiedDateTime'?: string | null;
}
export interface FwStandardBusinessLogicFwBusinessLogicFieldDefinition {
    'Name'?: string | null;
    'DataType'?: FwStandardSqlServerFwDataTypes;
    'ExcelOptions'?: FwStandardSqlServerAttributesFwExcelOptions;
    'MaxLength'?: number;
    'IsRequired'?: boolean;
    'IsPrimaryKey'?: boolean;
    'IsReadOnly'?: boolean;
    'DisplayFieldName'?: string | null;
    'AllowedValues'?: string | null;
    'TemplateSequence'?: number;
    'IsEmail'?: boolean;
}


export interface FwStandardDataFwCustomValue {
    'ModuleName'?: string | null;
    'FieldName'?: string | null;
    'FieldValue'?: string | null;
    'FieldType'?: string | null;
    'ValidationModule'?: string | null;
    'ValidationFieldName'?: string | null;
    'ValidationFieldId'?: string | null;
    'ListFieldAllowedValues'?: string | null;
}
export interface FwStandardDataFwDefaultAttribute {
    'FieldName'?: string | null;
    'AttributeName'?: string | null;
    'DefaultValue'?: string | null;
}
export interface FwStandardDataFwTranslatedValue {
    'FieldName'?: string | null;
    'TranslatedValue'?: string | null;
    'UntranslatedValue'?: string | null;
    'IsTranslated'?: boolean;
    'UserIsTranslating'?: boolean;
}
export interface FwStandardModelsFwApiException {
    'StatusCode'?: number;
    'Message'?: string;
    'StackTrace'?: string;
}
export interface FwStandardModelsFwQueryFilter {
    /**
     * The DataField name to filter on.
     */
    'Field': string;
    /**
     * Comparison operator: = (equals), <> (not equals)
     */
    'Op': string;
    /**
     * The value of the DataField to filter on.
     */
    'Value'?: string | null;
}
export interface FwStandardModelsFwQueryResponseStorefrontOrderDto {
    'Items'?: Array<StorefrontOrderDto> | null;
    'PageNo'?: number;
    'PageSize'?: number;
    'TotalItems'?: number;
    'Sort'?: string | null;
}
export interface FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader {
    'Items'?: Array<WebApiModulesIntegrationsStorefrontStorefrontProductL> | null;
    'PageNo'?: number;
    'PageSize'?: number;
    'TotalItems'?: number;
    'Sort'?: string | null;
}

export const FwStandardSqlServerAttributesFwExcelOptions = {
    Required: 'Required',
    Recommended: 'Recommended',
    Optional: 'Optional',
    Omit: 'Omit',
    None: 'None'
} as const;

export type FwStandardSqlServerAttributesFwExcelOptions = typeof FwStandardSqlServerAttributesFwExcelOptions[keyof typeof FwStandardSqlServerAttributesFwExcelOptions];



export const FwStandardSqlServerFwDataTypes = {
    Text: 'Text',
    NonTrimmableText: 'NonTrimmableText',
    Date: 'Date',
    Time: 'Time',
    DateTime: 'DateTime',
    DateTimeOffset: 'DateTimeOffset',
    CreditCardExpirationDate: 'CreditCardExpirationDate',
    Decimal: 'Decimal',
    DecimalStringNoTrailingZeros: 'DecimalStringNoTrailingZeros',
    DecimalString1Digit: 'DecimalString1Digit',
    DecimalString2Digits: 'DecimalString2Digits',
    DecimalString3Digits: 'DecimalString3Digits',
    DecimalString4Digits: 'DecimalString4Digits',
    DecimalString8Digits: 'DecimalString8Digits',
    Boolean: 'Boolean',
    CurrencyString: 'CurrencyString',
    CurrencyStringNoDollarSign: 'CurrencyStringNoDollarSign',
    CurrencyStringNoDollarSignNoDecimalPlaces: 'CurrencyStringNoDollarSignNoDecimalPlaces',
    PhoneUs: 'PhoneUS',
    ZipcodeUs: 'ZipcodeUS',
    PercentageWholeNumber: 'PercentageWholeNumber',
    Percentage2Digits: 'Percentage2Digits',
    Percentage4Digits: 'Percentage4Digits',
    OleToHtmlColor: 'OleToHtmlColor',
    Integer: 'Integer',
    JpgDataUrl: 'JpgDataUrl',
    UtcDateTime: 'UTCDateTime',
    Email: 'Email'
} as const;

export type FwStandardSqlServerFwDataTypes = typeof FwStandardSqlServerFwDataTypes[keyof typeof FwStandardSqlServerFwDataTypes];


export interface InventoryAvailabilityCalendarDateDto {
    'Available'?: number | null;
    'Day'?: string;
}
export interface InventoryAvailabilityCalendarEventDto {
    'start'?: string | null;
    'end'?: string | null;
    'text'?: string | null;
    'backColor'?: string | null;
    'textColor'?: string | null;
    'id'?: string | null;
}
export interface InventoryAvailabilityCalendarResponseDto {
    'Dates'?: Array<InventoryAvailabilityCalendarDateDto> | null;
    'InventoryAvailabilityCalendarEvents'?: Array<InventoryAvailabilityCalendarEventDto> | null;
}
export interface ShoppingCartItemDto {
    'inventoryId'?: string | null;
    'product'?: WebApiModulesIntegrationsStorefrontStorefrontProductL;
    'qty'?: number;
    'packageItemQtys'?: { [key: string]: number | null; } | null;
}
export interface StorefrontOrderDto {
    'OrderId'?: string | null;
    'OrderDate'?: string | null;
    'OrderType'?: string | null;
    'OrderNumber'?: string | null;
    'Description'?: string | null;
    'DealId'?: string | null;
    'Deal'?: string | null;
    'OrderTotal'?: string | null;
    'EstimatedStart'?: string | null;
    'EstimatedStop'?: string | null;
    'Status'?: string | null;
    'Warehouse'?: string | null;
}
export interface StorefrontPackageItem {
    'Images'?: Array<WebApiModulesIntegrationsStorefrontProductImage> | null;
    'ProductId'?: number;
    'InventoryPackageInventoryId'?: string | null;
    'ICode'?: string | null;
    'Description'?: string | null;
    'InventoryId'?: string | null;
    'IsPrimary'?: boolean;
    'DefaultQuantity'?: number | null;
    'DefaultQuantityColor'?: string | null;
    'IsOption'?: boolean;
    'Charge'?: boolean | null;
    'NoChargePrint'?: boolean | null;
    'IsRequired'?: boolean | null;
    'OptionColor'?: string | null;
    'ItemClass'?: string | null;
    'ItemTrackedBy'?: string | null;
    'AvailFor'?: string | null;
    'AvailFrom'?: string | null;
    'OrderBy'?: number | null;
    'ItemColor'?: string | null;
    'IsNestedComplete'?: string | null;
    'Inactive'?: string | null;
    'WarehouseId'?: string | null;
    'ParentId'?: string | null;
    'PackageItemClass'?: string | null;
    'ItemNonDiscountable'?: string | null;
    'PrimaryInventoryId'?: string | null;
    'UnitId'?: string | null;
    'PackageId'?: string | null;
    'Availability'?: WebApiModulesIntegrationsStorefrontProductAvailability;
    'DailyRate'?: number | null;
    'WeeklyRate'?: number | null;
    'MonthlyRate'?: number | null;
    'DailyExtended'?: number | null;
    'WeeklyExtended'?: number | null;
    'MonthlyExtended'?: number | null;
    'SalesPrice'?: number | null;
    'Retail'?: number | null;
    'CurrencyId'?: string | null;
    'CurrencyCode'?: string | null;
    'CurrencySymbol'?: string | null;
    'DateStamp'?: string | null;
}
export interface WebApiModulesAccountServicesJwtAzureADRequest {
    'Email'?: string | null;
    'Token'?: string | null;
    'Tenant'?: string | null;
    'Audience'?: string | null;
    'Issuer'?: string | null;
}
export interface WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto {
    'FullName'?: string | null;
    'Email'?: string | null;
    'DealId'?: string | null;
    'Deal'?: string | null;
    'HasStorefront'?: boolean;
    'HasPortal'?: boolean;
}
export interface WebApiModulesIntegrationsPortalServicesPortalSvcDtoDealResponseDto {
    'DealId'?: string | null;
    'Deal'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontContactRegistrationRequest {
    'Language'?: string | null;
    'FirstName': string;
    'LastName': string;
    'Phone'?: string | null;
    'Email': string;
    'StudentId'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontContactRegistrationResponse {
    'Success'?: boolean;
}
export interface WebApiModulesIntegrationsStorefrontDealModel {
    'DealId'?: string | null;
    'Deal'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontGetProductWarehouseDetailsResponse {
    'Availability'?: WebApiModulesIntegrationsStorefrontProductAvailability;
    'DailyRate'?: number;
    'WeeklyRate'?: number;
    'MonthlyRate'?: number;
    'CurrencySymbol'?: string | null;
    'CurrencyCode'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontLocationModel {
    'LocationId'?: string | null;
    'Location'?: string | null;
    'WarehouseId'?: string | null;
    'Warehouse'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontLoginRequest {
    'Email': string;
    'Password': string;
}
export interface WebApiModulesIntegrationsStorefrontProductAvailability {
    'TotalIn'?: number;
    'Total'?: number;
}
export interface WebApiModulesIntegrationsStorefrontProductCategory {
    'Id'?: string | null;
    'Name'?: string | null;
    'UrlName'?: string | null;
    'LinkUrl'?: string | null;
    'SubCategories'?: Array<WebApiModulesIntegrationsStorefrontProductSubCategory> | null;
}
export interface WebApiModulesIntegrationsStorefrontProductDepartment {
    'Id'?: string | null;
    'Name'?: string | null;
    'UrlName'?: string | null;
    'Categories'?: Array<WebApiModulesIntegrationsStorefrontProductCategory> | null;
}
export interface WebApiModulesIntegrationsStorefrontProductImage {
    'Id'?: string | null;
    'Url'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontProductSubCategory {
    'Id'?: string | null;
    'Name'?: string | null;
    'UrlName'?: string | null;
    'LinkUrl'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontQuoteRequest {
    'WebCatalogId'?: string | null;
    'Language'?: string | null;
    'DepartmentId': string;
    'LocationId': string;
    'WarehouseId': string;
    'DealId'?: string | null;
    'QuoteDescription'?: string | null;
    'JobName'?: string | null;
    'StartDate': string;
    'StartTime'?: string | null;
    'StopDate': string;
    'StopTime'?: string | null;
    'Notes'?: string | null;
    'Items': Array<WebApiModulesIntegrationsStorefrontQuoteRequestItem>;
}
export interface WebApiModulesIntegrationsStorefrontQuoteRequestItem {
    'InventoryId': string;
    'WebCatalogId': string;
    'Qty': number;
    'PackageItems'?: Array<WebApiModulesIntegrationsStorefrontQuoteRequestPackageItem> | null;
}
export interface WebApiModulesIntegrationsStorefrontQuoteRequestPackageItem {
    'InventoryId': string;
    'InventoryPackageInventoryId': string;
    'Qty': number;
}
export interface WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest {
    'Email': string;
    'TemporaryPassword': string;
    'NewPassword': string;
}
export interface WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest {
    'CatalogProductId': string;
    'WarehouseId': string;
    'LocationId': string;
    'FirstName': string;
    'LastName': string;
    'Phone': string;
    'Email': string;
    'Message': string;
}
export interface WebApiModulesIntegrationsStorefrontSendInquiryEmailResponse {
    'Success'?: boolean;
    'FailureMessage'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest {
    'EmailTo': string;
    'Language'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontStorefrontProductL {
    '_Custom'?: Array<FwStandardDataFwCustomValue> | null;
    '_DefaultFieldAttributes'?: Array<FwStandardDataFwDefaultAttribute> | null;
    '_Translation'?: Array<FwStandardDataFwTranslatedValue> | null;
    '_HasImport'?: boolean | null;
    '_HasDocuments'?: boolean | null;
    'Id'?: number;
    'WarehouseId'?: string | null;
    'InventoryId'?: string | null;
    'InventoryNo'?: string | null;
    'ItemName'?: string | null;
    'Keywords'?: string | null;
    'Tags'?: string | null;
    'Barcodes'?: string | null;
    'ItemUrlName'?: string | null;
    'DetailedDescription'?: string | null;
    'TechnicalNotes'?: string | null;
    'Classification'?: string | null;
    'AvailableFor'?: string | null;
    'Owned'?: number;
    'InventoryTypeOrderBy'?: string | null;
    'CategoryOrderBy'?: string | null;
    'SubCategoryOrderBy'?: string | null;
    'MasterOrderBy'?: string | null;
    'Availability'?: WebApiModulesIntegrationsStorefrontProductAvailability;
    'WarehouseSpecific'?: boolean | null;
    'PackagePrice'?: string | null;
    'DailyRate'?: number | null;
    'WeeklyRate'?: number | null;
    'MonthlyRate'?: number | null;
    'SalesPrice'?: number | null;
    'CurrencySymbol'?: string | null;
    'CurrencyCode'?: string | null;
    'PackageItems'?: Array<StorefrontPackageItem> | null;
    'Manufacturer'?: string | null;
    'ManufacturerPartNumber'?: string | null;
    'ManufacturerUrl'?: string | null;
    'UnitValue'?: number | null;
    'ReplacementCost'?: number | null;
    'ShipWeightLbs'?: number | null;
    'ShipWeightOz'?: number | null;
    'Images'?: Array<WebApiModulesIntegrationsStorefrontProductImage> | null;
    'WebCatalogId'?: string | null;
    'WebCatalog'?: string | null;
    'WebCatalogUrlName'?: string | null;
    'InventoryDepartmentId'?: string | null;
    'InventoryDepartment'?: string | null;
    'InventoryDepartmentUrlName'?: string | null;
    'CategoryId'?: string | null;
    'Category'?: string | null;
    'CategoryUrlName'?: string | null;
    'SubCategoryId'?: string | null;
    'SubCategory'?: string | null;
    'SubCategoryUrlName'?: string | null;
    '_Original'?: FwStandardBusinessLogicFwBusinessLogic;
    'CreatedByUserId'?: string | null;
    'CreatedByUserName'?: string | null;
    'CreatedDateTime'?: string | null;
    'ModifiedByUserId'?: string | null;
    'ModifiedByUserName'?: string | null;
    'ModifiedDateTime'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontStorefrontProgress {
    'LastUpdated'?: string;
    'Failed'?: boolean;
    'FailureMessage'?: string | null;
    'FailureStackTrace'?: string | null;
    'SessionId'?: string | null;
    'Caption'?: string | null;
    'CurrentStep'?: number | null;
    'TotalSteps'?: number | null;
    'PercentComplete'?: number | null;
}
export interface WebApiModulesIntegrationsStorefrontStorefrontSettings {
    'IsStorefrontEnabled'?: boolean | null;
    'IsAnonymousAccessEnabled'?: boolean | null;
    'RegisterEnabled'?: boolean | null;
    'SeparateQuoteRequestsByCatalog'?: boolean | null;
    'MakeQuoteRequestIntoOrderOnSubmission'?: boolean | null;
    'FilterCatalogsByLocation'?: boolean | null;
    'PhoneNoRequiredOnRegistrationForm'?: boolean | null;
    'IsUniversity'?: boolean | null;
    'StudentIdRequiredOnRegistrationForm'?: boolean | null;
    'AutoplaySpeed'?: number | null;
    'AutoplayImagesOnLandingPage'?: boolean | null;
    'AutoplayImagesOnProductBrowser'?: boolean | null;
    'AutoplayImagesOnProductDetails'?: boolean | null;
    'ImagesTransitionEffect'?: string | null;
    'ImagesTransitionSpeed'?: string | null;
    'HomepageShowSiteHeader'?: boolean | null;
    'HomepageShowHeroSection'?: boolean | null;
    'HomepageHeroSectionHeading1'?: WebApiModulesIntegrationsStorefrontStorefrontTranslatedText;
    'HomepageHeroSectionHeading2'?: WebApiModulesIntegrationsStorefrontStorefrontTranslatedText;
    'HomepageHeroSectionHeading3'?: WebApiModulesIntegrationsStorefrontStorefrontTranslatedText;
    'HomepageCatalogItemWidth'?: string | null;
    'HomepageCatalogItemHeight'?: string | null;
    'HomepageShowFooter'?: boolean | null;
    'HomepageFooterText'?: WebApiModulesIntegrationsStorefrontStorefrontTranslatedText;
    'LandingPageShowCategoryBrowser'?: boolean | null;
    'LandingPageCategoryBrowserItemWidth'?: string | null;
    'ShowReservationHourFields'?: boolean | null;
    'ToDateAdjustmentDays'?: number | null;
    'EnableHoursOfOperation'?: boolean | null;
    'OpenTime'?: string | null;
    'CloseTime'?: string | null;
    'EnableOpenDays'?: boolean | null;
    'OpenSunday'?: boolean | null;
    'OpenMonday'?: boolean | null;
    'OpenTuesday'?: boolean | null;
    'OpenWednesday'?: boolean | null;
    'OpenThursday'?: boolean | null;
    'OpenFriday'?: boolean | null;
    'OpenSaturday'?: boolean | null;
    'ShowOwnedQty'?: boolean | null;
    'ShowAvailabilityCalendar'?: boolean | null;
    'InitialAvailabilityCalendarView'?: string | null;
}

export const WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes = {
    Boolean: 'Boolean',
    Text: 'Text',
    TranslatedText: 'TranslatedText',
    DropDown: 'DropDown',
    Number: 'Number',
    TimePicker24: 'TimePicker24'
} as const;

export type WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes = typeof WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes[keyof typeof WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes];


export interface WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchema {
    'Group'?: string | null;
    'Caption'?: string | null;
    'PropertyName'?: string | null;
    'DataType'?: WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertyDataTypes;
    'Description'?: string | null;
    'ValidValues'?: Array<WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchemaValidValue> | null;
}


export interface WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchemaValidValue {
    'caption'?: string | null;
    'value'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontStorefrontTranslatedText {
    'en'?: string | null;
    'es'?: string | null;
    'fr'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontSubmitQuoteRequestResponse {
    'Success'?: boolean;
    'FailureMessage'?: string | null;
    'ProgressMeterSessionId'?: string | null;
}
export interface WebApiModulesIntegrationsStorefrontWebCatalog {
    'Id'?: string | null;
    'Name'?: string | null;
    'UrlName'?: string | null;
    'DealId'?: string | null;
    'DepartmentId'?: string | null;
    'LocationId'?: string | null;
    'WarehouseId'?: string | null;
    'AllowAddingUnavailableItems'?: boolean | null;
    'HasRental'?: boolean | null;
    'HasSales'?: boolean | null;
    'GridFields'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogResponseField> | null;
    'ListFields'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogResponseField> | null;
    'DetailFields'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogResponseField> | null;
    'ShoppingCartFields'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogResponseField> | null;
    'Images'?: string | null;
    'LandingPageHtml'?: string | null;
    'Departments'?: Array<WebApiModulesIntegrationsStorefrontProductDepartment> | null;
    'WarehousesQtys'?: Array<WebApiModulesIntegrationsStorefrontWebCatalogWarehouseQtyDto> | null;
}
export interface WebApiModulesIntegrationsStorefrontWebCatalogResponseField {
    'Value'?: string | null;
    'Text'?: string | null;
    'Selected'?: boolean;
}
export interface WebApiModulesIntegrationsStorefrontWebCatalogWarehouseQtyDto {
    'WarehouseId'?: string | null;
    'TotalItems'?: number;
}

/**
 * StorefrontApi - axios parameter creator
 */
export const StorefrontApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a list of Deals that the Contact is a member of.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontDealsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout (for Contacts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of items in the Storefront shopping cart format based on items in an order
         * @param {string} [orderId] 
         * @param {string} [webCatalogId] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontOrderToShoppingCartItemsPost: async (orderId?: string, webCatalogId?: string, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/order-to-shopping-cart-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            if (webCatalogId !== undefined) {
                localVarQueryParameter['WebCatalogId'] = webCatalogId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = toDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get orders for a contact\'s deal (in the api token).
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontOrdersGet: async (pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Renders an order report and returns a URL to the PDF.
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontRenderOrderReportPost: async (orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/render-order-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Renders a quote report and returns a URL to the PDF.
         * @param {string} [quoteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontRenderQuoteReportPost: async (quoteId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/render-quote-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteId !== undefined) {
                localVarQueryParameter['QuoteId'] = quoteId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with Azure/Entra ID (for Contacts)
         * @param {WebApiModulesAccountServicesJwtAzureADRequest} [webApiModulesAccountServicesJwtAzureADRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        azureLoginAsync: async (webApiModulesAccountServicesJwtAzureADRequest?: WebApiModulesAccountServicesJwtAzureADRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/login/azure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesAccountServicesJwtAzureADRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get availability calendar data.
         * @param {string} inventoryId 
         * @param {string} warehouseId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilityCalendarAsync: async (inventoryId: string, warehouseId: string, fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryId' is not null or undefined
            assertParamExists('getAvailabilityCalendarAsync', 'inventoryId', inventoryId)
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('getAvailabilityCalendarAsync', 'warehouseId', warehouseId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getAvailabilityCalendarAsync', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getAvailabilityCalendarAsync', 'toDate', toDate)
            const localVarPath = `/api/v1/storefront/availability-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inventoryId !== undefined) {
                localVarQueryParameter['InventoryId'] = inventoryId;
            }

            if (warehouseId !== undefined) {
                localVarQueryParameter['WarehouseId'] = warehouseId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['FromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['ToDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get catalog by id.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogByIdAsync: async (catalogid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogid' is not null or undefined
            assertParamExists('getCatalogByIdAsync', 'catalogid', catalogid)
            const localVarPath = `/api/v1/storefront/catalog/{catalogid}`
                .replace(`{${"catalogid"}}`, encodeURIComponent(String(catalogid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get catalogs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogsAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get categorytree for a catalog.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryTreeAsync: async (catalogid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogid' is not null or undefined
            assertParamExists('getCategoryTreeAsync', 'catalogid', catalogid)
            const localVarPath = `/api/v1/storefront/catalog/{catalogid}/categorytree`
                .replace(`{${"catalogid"}}`, encodeURIComponent(String(catalogid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lookup a list of valid deals for submitting quote requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/lookupdeal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lookup locations for a warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/lookuplocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get product details of a single product, availability will be defaulted to today + 6 days and use the location/warehouse from the product\'s catalog.
         * @param {string} productid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAsync: async (productid: string, warehouseid: string, locationid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productid' is not null or undefined
            assertParamExists('getProductAsync', 'productid', productid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('getProductAsync', 'warehouseid', warehouseid)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('getProductAsync', 'locationid', locationid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('getProductAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('getProductAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/product/{productid}/warehouseid/{warehouseid}/locationid/{locationid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"productid"}}`, encodeURIComponent(String(productid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inventoryid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAvailabilityAsync: async (inventoryid: string, warehouseid: string, fromdate: string, todate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryid' is not null or undefined
            assertParamExists('getProductAvailabilityAsync', 'inventoryid', inventoryid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('getProductAvailabilityAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('getProductAvailabilityAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('getProductAvailabilityAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/productavailability/inventoryid/{inventoryid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"inventoryid"}}`, encodeURIComponent(String(inventoryid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get extended product details with availability and rates
         * @param {string} productid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetailsAsync: async (productid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productid' is not null or undefined
            assertParamExists('getProductDetailsAsync', 'productid', productid)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('getProductDetailsAsync', 'locationid', locationid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('getProductDetailsAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('getProductDetailsAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('getProductDetailsAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/productdetails/productid/{productid}/locationid/{locationid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"productid"}}`, encodeURIComponent(String(productid)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the current status from a progress meter session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgressMeterAsync: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProgressMeterAsync', 'id', id)
            const localVarPath = `/api/v1/storefront/progressmeter/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorefrontSettingsAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorefrontSettingsSchemaAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/settings/schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the storefront api version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lookup warehouses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehousesAsync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/lookupwarehouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products in a catalog.
         * @param {string} catalogid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebCatalogProductsAsync: async (catalogid: string, warehouseid: string, locationid: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogid' is not null or undefined
            assertParamExists('getWebCatalogProductsAsync', 'catalogid', catalogid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('getWebCatalogProductsAsync', 'warehouseid', warehouseid)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('getWebCatalogProductsAsync', 'locationid', locationid)
            const localVarPath = `/api/v1/storefront/catalog/{catalogid}/products/warehouseid/{warehouseid}/locationid/{locationid}`
                .replace(`{${"catalogid"}}`, encodeURIComponent(String(catalogid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (inventorydepartmentid !== undefined) {
                localVarQueryParameter['inventorydepartmentid'] = inventorydepartmentid;
            }

            if (categoryid !== undefined) {
                localVarQueryParameter['categoryid'] = categoryid;
            }

            if (subcategoryid !== undefined) {
                localVarQueryParameter['subcategoryid'] = subcategoryid;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products by id with availability.  (for revalidating shopping cart)
         * @param {string} productids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebCatalogProductsByIdWithAvailabilityAsync: async (productids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productids' is not null or undefined
            assertParamExists('getWebCatalogProductsByIdWithAvailabilityAsync', 'productids', productids)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('getWebCatalogProductsByIdWithAvailabilityAsync', 'locationid', locationid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('getWebCatalogProductsByIdWithAvailabilityAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('getWebCatalogProductsByIdWithAvailabilityAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('getWebCatalogProductsByIdWithAvailabilityAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/products/{productids}/locationid/{locationid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"productids"}}`, encodeURIComponent(String(productids)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products by comma separated list of InventoryIds with availability.   (When a product is removed from a catalog the catalog\'s product id will change, so we can query this endpoint to update the product ids in a users shopping cart if we can find the same InventoryId on a different catalog listing.
         * @param {string} inventoryids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebCatalogProductsByInventoryIdsWithAvailabilityAsync: async (inventoryids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryids' is not null or undefined
            assertParamExists('getWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'inventoryids', inventoryids)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('getWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'locationid', locationid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('getWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('getWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('getWebCatalogProductsByInventoryIdsWithAvailabilityAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/products/inventoryids/{inventoryids}/locationid/{locationid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"inventoryids"}}`, encodeURIComponent(String(inventoryids)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get products in a catalog with availability.
         * @param {string} catalogid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebCatalogProductsWithAvailabilityAsync: async (catalogid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogid' is not null or undefined
            assertParamExists('getWebCatalogProductsWithAvailabilityAsync', 'catalogid', catalogid)
            // verify required parameter 'locationid' is not null or undefined
            assertParamExists('getWebCatalogProductsWithAvailabilityAsync', 'locationid', locationid)
            // verify required parameter 'warehouseid' is not null or undefined
            assertParamExists('getWebCatalogProductsWithAvailabilityAsync', 'warehouseid', warehouseid)
            // verify required parameter 'fromdate' is not null or undefined
            assertParamExists('getWebCatalogProductsWithAvailabilityAsync', 'fromdate', fromdate)
            // verify required parameter 'todate' is not null or undefined
            assertParamExists('getWebCatalogProductsWithAvailabilityAsync', 'todate', todate)
            const localVarPath = `/api/v1/storefront/catalog/{catalogid}/products/locationid/{locationid}/warehouseid/{warehouseid}/fromdate/{fromdate}/todate/{todate}`
                .replace(`{${"catalogid"}}`, encodeURIComponent(String(catalogid)))
                .replace(`{${"locationid"}}`, encodeURIComponent(String(locationid)))
                .replace(`{${"warehouseid"}}`, encodeURIComponent(String(warehouseid)))
                .replace(`{${"fromdate"}}`, encodeURIComponent(String(fromdate)))
                .replace(`{${"todate"}}`, encodeURIComponent(String(todate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageno !== undefined) {
                localVarQueryParameter['pageno'] = pageno;
            }

            if (pagesize !== undefined) {
                localVarQueryParameter['pagesize'] = pagesize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (inventorydepartmentid !== undefined) {
                localVarQueryParameter['inventorydepartmentid'] = inventorydepartmentid;
            }

            if (categoryid !== undefined) {
                localVarQueryParameter['categoryid'] = categoryid;
            }

            if (subcategoryid !== undefined) {
                localVarQueryParameter['subcategoryid'] = subcategoryid;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontLoginRequest} [webApiModulesIntegrationsStorefrontLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsync: async (webApiModulesIntegrationsStorefrontLoginRequest?: WebApiModulesIntegrationsStorefrontLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register a new account (Contact)
         * @param {WebApiModulesIntegrationsStorefrontContactRegistrationRequest} [webApiModulesIntegrationsStorefrontContactRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAsync: async (webApiModulesIntegrationsStorefrontContactRegistrationRequest?: WebApiModulesIntegrationsStorefrontContactRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontContactRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest} [webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordFromEmailAsync: async (webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest?: WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/resetpasswordfromemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send email to Change Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChangePasswordEmailAsync: async (webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/sendchangepasswordemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send an inquiry email about an item.
         * @param {WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest} [webApiModulesIntegrationsStorefrontSendInquiryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInquiryEmailRequestAsync: async (webApiModulesIntegrationsStorefrontSendInquiryEmailRequest?: WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/sendinquiryemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordEmailAsync: async (webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/sendresetpasswordemail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit a Quote Request
         * @param {WebApiModulesIntegrationsStorefrontQuoteRequest} [webApiModulesIntegrationsStorefrontQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitQuoteRequestAsync: async (webApiModulesIntegrationsStorefrontQuoteRequest?: WebApiModulesIntegrationsStorefrontQuoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/storefront/submitquoterequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webApiModulesIntegrationsStorefrontQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorefrontApi - functional programming interface
 */
export const StorefrontApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorefrontApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns a list of Deals that the Contact is a member of.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StorefrontDealsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsPortalServicesPortalSvcDtoDealResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StorefrontDealsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.apiV1StorefrontDealsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout (for Contacts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StorefrontLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StorefrontLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.apiV1StorefrontLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns a list of items in the Storefront shopping cart format based on items in an order
         * @param {string} [orderId] 
         * @param {string} [webCatalogId] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StorefrontOrderToShoppingCartItemsPost(orderId?: string, webCatalogId?: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShoppingCartItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StorefrontOrderToShoppingCartItemsPost(orderId, webCatalogId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.apiV1StorefrontOrderToShoppingCartItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get orders for a contact\'s deal (in the api token).
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StorefrontOrdersGet(pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseStorefrontOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StorefrontOrdersGet(pageno, pagesize, sort, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.apiV1StorefrontOrdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Renders an order report and returns a URL to the PDF.
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StorefrontRenderOrderReportPost(orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StorefrontRenderOrderReportPost(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.apiV1StorefrontRenderOrderReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Renders a quote report and returns a URL to the PDF.
         * @param {string} [quoteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1StorefrontRenderQuoteReportPost(quoteId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1StorefrontRenderQuoteReportPost(quoteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.apiV1StorefrontRenderQuoteReportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with Azure/Entra ID (for Contacts)
         * @param {WebApiModulesAccountServicesJwtAzureADRequest} [webApiModulesAccountServicesJwtAzureADRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async azureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest?: WebApiModulesAccountServicesJwtAzureADRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.azureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.azureLoginAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get availability calendar data.
         * @param {string} inventoryId 
         * @param {string} warehouseId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailabilityCalendarAsync(inventoryId: string, warehouseId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryAvailabilityCalendarResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailabilityCalendarAsync(inventoryId, warehouseId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getAvailabilityCalendarAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get catalog by id.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogByIdAsync(catalogid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontWebCatalog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogByIdAsync(catalogid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getCatalogByIdAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get catalogs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogsAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontWebCatalog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogsAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getCatalogsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get categorytree for a catalog.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryTreeAsync(catalogid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontWebCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryTreeAsync(catalogid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getCategoryTreeAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lookup a list of valid deals for submitting quote requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDealAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontDealModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDealAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getDealAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lookup locations for a warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontLocationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getLocationsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get product details of a single product, availability will be defaulted to today + 6 days and use the location/warehouse from the product\'s catalog.
         * @param {string} productid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAsync(productid: string, warehouseid: string, locationid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontProductL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAsync(productid, warehouseid, locationid, fromdate, todate, pageno, pagesize, sort, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getProductAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inventoryid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAvailabilityAsync(inventoryid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontProductAvailability>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAvailabilityAsync(inventoryid, warehouseid, fromdate, todate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getProductAvailabilityAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get extended product details with availability and rates
         * @param {string} productid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDetailsAsync(productid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontGetProductWarehouseDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDetailsAsync(productid, locationid, warehouseid, fromdate, todate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getProductDetailsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the current status from a progress meter session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProgressMeterAsync(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontProgress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProgressMeterAsync(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getProgressMeterAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStorefrontSettingsAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStorefrontSettingsAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getStorefrontSettingsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStorefrontSettingsSchemaAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStorefrontSettingsSchemaAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getStorefrontSettingsSchemaAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the storefront api version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getVersionAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lookup warehouses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarehousesAsync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebApiModulesIntegrationsStorefrontLocationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWarehousesAsync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getWarehousesAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products in a catalog.
         * @param {string} catalogid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebCatalogProductsAsync(catalogid: string, warehouseid: string, locationid: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebCatalogProductsAsync(catalogid, warehouseid, locationid, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getWebCatalogProductsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products by id with availability.  (for revalidating shopping cart)
         * @param {string} productids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebCatalogProductsByIdWithAvailabilityAsync(productids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebCatalogProductsByIdWithAvailabilityAsync(productids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getWebCatalogProductsByIdWithAvailabilityAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products by comma separated list of InventoryIds with availability.   (When a product is removed from a catalog the catalog\'s product id will change, so we can query this endpoint to update the product ids in a users shopping cart if we can find the same InventoryId on a different catalog listing.
         * @param {string} inventoryids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getWebCatalogProductsByInventoryIdsWithAvailabilityAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get products in a catalog with availability.
         * @param {string} catalogid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebCatalogProductsWithAvailabilityAsync(catalogid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebCatalogProductsWithAvailabilityAsync(catalogid, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.getWebCatalogProductsWithAvailabilityAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontLoginRequest} [webApiModulesIntegrationsStorefrontLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAsync(webApiModulesIntegrationsStorefrontLoginRequest?: WebApiModulesIntegrationsStorefrontLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAsync(webApiModulesIntegrationsStorefrontLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.loginAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register a new account (Contact)
         * @param {WebApiModulesIntegrationsStorefrontContactRegistrationRequest} [webApiModulesIntegrationsStorefrontContactRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest?: WebApiModulesIntegrationsStorefrontContactRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontContactRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.registerAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest} [webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest?: WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.resetPasswordFromEmailAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send email to Change Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.sendChangePasswordEmailAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send an inquiry email about an item.
         * @param {WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest} [webApiModulesIntegrationsStorefrontSendInquiryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest?: WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontSendInquiryEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.sendInquiryEmailRequestAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.sendResetPasswordEmailAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit a Quote Request
         * @param {WebApiModulesIntegrationsStorefrontQuoteRequest} [webApiModulesIntegrationsStorefrontQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest?: WebApiModulesIntegrationsStorefrontQuoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebApiModulesIntegrationsStorefrontSubmitQuoteRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorefrontApi.submitQuoteRequestAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StorefrontApi - factory interface
 */
export const StorefrontApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorefrontApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns a list of Deals that the Contact is a member of.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontDealsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsPortalServicesPortalSvcDtoDealResponseDto>> {
            return localVarFp.apiV1StorefrontDealsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout (for Contacts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1StorefrontLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of items in the Storefront shopping cart format based on items in an order
         * @param {string} [orderId] 
         * @param {string} [webCatalogId] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontOrderToShoppingCartItemsPost(orderId?: string, webCatalogId?: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ShoppingCartItemDto>> {
            return localVarFp.apiV1StorefrontOrderToShoppingCartItemsPost(orderId, webCatalogId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get orders for a contact\'s deal (in the api token).
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontOrdersGet(pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseStorefrontOrderDto> {
            return localVarFp.apiV1StorefrontOrdersGet(pageno, pagesize, sort, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Renders an order report and returns a URL to the PDF.
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontRenderOrderReportPost(orderId?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1StorefrontRenderOrderReportPost(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Renders a quote report and returns a URL to the PDF.
         * @param {string} [quoteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1StorefrontRenderQuoteReportPost(quoteId?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV1StorefrontRenderQuoteReportPost(quoteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with Azure/Entra ID (for Contacts)
         * @param {WebApiModulesAccountServicesJwtAzureADRequest} [webApiModulesAccountServicesJwtAzureADRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        azureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest?: WebApiModulesAccountServicesJwtAzureADRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto> {
            return localVarFp.azureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get availability calendar data.
         * @param {string} inventoryId 
         * @param {string} warehouseId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilityCalendarAsync(inventoryId: string, warehouseId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): AxiosPromise<InventoryAvailabilityCalendarResponseDto> {
            return localVarFp.getAvailabilityCalendarAsync(inventoryId, warehouseId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get catalog by id.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogByIdAsync(catalogid: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontWebCatalog>> {
            return localVarFp.getCatalogByIdAsync(catalogid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get catalogs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogsAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontWebCatalog>> {
            return localVarFp.getCatalogsAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get categorytree for a catalog.
         * @param {string} catalogid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryTreeAsync(catalogid: string, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontWebCatalog> {
            return localVarFp.getCategoryTreeAsync(catalogid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lookup a list of valid deals for submitting quote requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontDealModel>> {
            return localVarFp.getDealAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lookup locations for a warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontLocationModel>> {
            return localVarFp.getLocationsAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get product details of a single product, availability will be defaulted to today + 6 days and use the location/warehouse from the product\'s catalog.
         * @param {string} productid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAsync(productid: string, warehouseid: string, locationid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontProductL> {
            return localVarFp.getProductAsync(productid, warehouseid, locationid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} inventoryid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAvailabilityAsync(inventoryid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontProductAvailability> {
            return localVarFp.getProductAvailabilityAsync(inventoryid, warehouseid, fromdate, todate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get extended product details with availability and rates
         * @param {string} productid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetailsAsync(productid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontGetProductWarehouseDetailsResponse> {
            return localVarFp.getProductDetailsAsync(productid, locationid, warehouseid, fromdate, todate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the current status from a progress meter session.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgressMeterAsync(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontProgress> {
            return localVarFp.getProgressMeterAsync(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorefrontSettingsAsync(options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontStorefrontSettings> {
            return localVarFp.getStorefrontSettingsAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns storefront settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStorefrontSettingsSchemaAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontStorefrontSettingsPropertySchema>> {
            return localVarFp.getStorefrontSettingsSchemaAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the storefront api version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionAsync(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getVersionAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lookup warehouses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehousesAsync(options?: RawAxiosRequestConfig): AxiosPromise<Array<WebApiModulesIntegrationsStorefrontLocationModel>> {
            return localVarFp.getWarehousesAsync(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products in a catalog.
         * @param {string} catalogid 
         * @param {string} warehouseid 
         * @param {string} locationid 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebCatalogProductsAsync(catalogid: string, warehouseid: string, locationid: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader> {
            return localVarFp.getWebCatalogProductsAsync(catalogid, warehouseid, locationid, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products by id with availability.  (for revalidating shopping cart)
         * @param {string} productids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebCatalogProductsByIdWithAvailabilityAsync(productids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader> {
            return localVarFp.getWebCatalogProductsByIdWithAvailabilityAsync(productids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products by comma separated list of InventoryIds with availability.   (When a product is removed from a catalog the catalog\'s product id will change, so we can query this endpoint to update the product ids in a users shopping cart if we can find the same InventoryId on a different catalog listing.
         * @param {string} inventoryids 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader> {
            return localVarFp.getWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get products in a catalog with availability.
         * @param {string} catalogid 
         * @param {string} locationid 
         * @param {string} warehouseid 
         * @param {string} fromdate 
         * @param {string} todate 
         * @param {number} [pageno] 
         * @param {number} [pagesize] 
         * @param {string} [sort] 
         * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
         * @param {string} [inventorydepartmentid] 
         * @param {string} [categoryid] 
         * @param {string} [subcategoryid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebCatalogProductsWithAvailabilityAsync(catalogid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig): AxiosPromise<FwStandardModelsFwQueryResponseWebApiModulesIntegrationsStorefrontStorefrontProductLoader> {
            return localVarFp.getWebCatalogProductsWithAvailabilityAsync(catalogid, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontLoginRequest} [webApiModulesIntegrationsStorefrontLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsync(webApiModulesIntegrationsStorefrontLoginRequest?: WebApiModulesIntegrationsStorefrontLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto> {
            return localVarFp.loginAsync(webApiModulesIntegrationsStorefrontLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register a new account (Contact)
         * @param {WebApiModulesIntegrationsStorefrontContactRegistrationRequest} [webApiModulesIntegrationsStorefrontContactRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest?: WebApiModulesIntegrationsStorefrontContactRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontContactRegistrationResponse> {
            return localVarFp.registerAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest} [webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest?: WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsPortalAuthSvcLoginResponseDto> {
            return localVarFp.resetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send email to Change Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send an inquiry email about an item.
         * @param {WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest} [webApiModulesIntegrationsStorefrontSendInquiryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest?: WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontSendInquiryEmailResponse> {
            return localVarFp.sendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send email to Reset Password (for Contacts)
         * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit a Quote Request
         * @param {WebApiModulesIntegrationsStorefrontQuoteRequest} [webApiModulesIntegrationsStorefrontQuoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest?: WebApiModulesIntegrationsStorefrontQuoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebApiModulesIntegrationsStorefrontSubmitQuoteRequestResponse> {
            return localVarFp.submitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorefrontApi - object-oriented interface
 */
export class StorefrontApi extends BaseAPI {
    /**
     * 
     * @summary Returns a list of Deals that the Contact is a member of.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1StorefrontDealsGet(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).apiV1StorefrontDealsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout (for Contacts)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1StorefrontLogoutPost(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).apiV1StorefrontLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of items in the Storefront shopping cart format based on items in an order
     * @param {string} [orderId] 
     * @param {string} [webCatalogId] 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1StorefrontOrderToShoppingCartItemsPost(orderId?: string, webCatalogId?: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).apiV1StorefrontOrderToShoppingCartItemsPost(orderId, webCatalogId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get orders for a contact\'s deal (in the api token).
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1StorefrontOrdersGet(pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).apiV1StorefrontOrdersGet(pageno, pagesize, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Renders an order report and returns a URL to the PDF.
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1StorefrontRenderOrderReportPost(orderId?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).apiV1StorefrontRenderOrderReportPost(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Renders a quote report and returns a URL to the PDF.
     * @param {string} [quoteId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1StorefrontRenderQuoteReportPost(quoteId?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).apiV1StorefrontRenderQuoteReportPost(quoteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with Azure/Entra ID (for Contacts)
     * @param {WebApiModulesAccountServicesJwtAzureADRequest} [webApiModulesAccountServicesJwtAzureADRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public azureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest?: WebApiModulesAccountServicesJwtAzureADRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).azureLoginAsync(webApiModulesAccountServicesJwtAzureADRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get availability calendar data.
     * @param {string} inventoryId 
     * @param {string} warehouseId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAvailabilityCalendarAsync(inventoryId: string, warehouseId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getAvailabilityCalendarAsync(inventoryId, warehouseId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get catalog by id.
     * @param {string} catalogid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCatalogByIdAsync(catalogid: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getCatalogByIdAsync(catalogid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get catalogs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCatalogsAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getCatalogsAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get categorytree for a catalog.
     * @param {string} catalogid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCategoryTreeAsync(catalogid: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getCategoryTreeAsync(catalogid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lookup a list of valid deals for submitting quote requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDealAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getDealAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lookup locations for a warehouse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLocationsAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getLocationsAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get product details of a single product, availability will be defaulted to today + 6 days and use the location/warehouse from the product\'s catalog.
     * @param {string} productid 
     * @param {string} warehouseid 
     * @param {string} locationid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProductAsync(productid: string, warehouseid: string, locationid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getProductAsync(productid, warehouseid, locationid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} inventoryid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProductAvailabilityAsync(inventoryid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getProductAvailabilityAsync(inventoryid, warehouseid, fromdate, todate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get extended product details with availability and rates
     * @param {string} productid 
     * @param {string} locationid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProductDetailsAsync(productid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getProductDetailsAsync(productid, locationid, warehouseid, fromdate, todate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the current status from a progress meter session.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProgressMeterAsync(id: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getProgressMeterAsync(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns storefront settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStorefrontSettingsAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getStorefrontSettingsAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns storefront settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStorefrontSettingsSchemaAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getStorefrontSettingsSchemaAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the storefront api version.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVersionAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getVersionAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lookup warehouses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWarehousesAsync(options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getWarehousesAsync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products in a catalog.
     * @param {string} catalogid 
     * @param {string} warehouseid 
     * @param {string} locationid 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {string} [inventorydepartmentid] 
     * @param {string} [categoryid] 
     * @param {string} [subcategoryid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebCatalogProductsAsync(catalogid: string, warehouseid: string, locationid: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getWebCatalogProductsAsync(catalogid, warehouseid, locationid, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products by id with availability.  (for revalidating shopping cart)
     * @param {string} productids 
     * @param {string} locationid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebCatalogProductsByIdWithAvailabilityAsync(productids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getWebCatalogProductsByIdWithAvailabilityAsync(productids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products by comma separated list of InventoryIds with availability.   (When a product is removed from a catalog the catalog\'s product id will change, so we can query this endpoint to update the product ids in a users shopping cart if we can find the same InventoryId on a different catalog listing.
     * @param {string} inventoryids 
     * @param {string} locationid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getWebCatalogProductsByInventoryIdsWithAvailabilityAsync(inventoryids, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get products in a catalog with availability.
     * @param {string} catalogid 
     * @param {string} locationid 
     * @param {string} warehouseid 
     * @param {string} fromdate 
     * @param {string} todate 
     * @param {number} [pageno] 
     * @param {number} [pagesize] 
     * @param {string} [sort] 
     * @param {Array<FwStandardModelsFwQueryFilter>} [filter] 
     * @param {string} [inventorydepartmentid] 
     * @param {string} [categoryid] 
     * @param {string} [subcategoryid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebCatalogProductsWithAvailabilityAsync(catalogid: string, locationid: string, warehouseid: string, fromdate: string, todate: string, pageno?: number, pagesize?: number, sort?: string, filter?: Array<FwStandardModelsFwQueryFilter>, inventorydepartmentid?: string, categoryid?: string, subcategoryid?: string, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).getWebCatalogProductsWithAvailabilityAsync(catalogid, locationid, warehouseid, fromdate, todate, pageno, pagesize, sort, filter, inventorydepartmentid, categoryid, subcategoryid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login (for Contacts)
     * @param {WebApiModulesIntegrationsStorefrontLoginRequest} [webApiModulesIntegrationsStorefrontLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public loginAsync(webApiModulesIntegrationsStorefrontLoginRequest?: WebApiModulesIntegrationsStorefrontLoginRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).loginAsync(webApiModulesIntegrationsStorefrontLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register a new account (Contact)
     * @param {WebApiModulesIntegrationsStorefrontContactRegistrationRequest} [webApiModulesIntegrationsStorefrontContactRegistrationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest?: WebApiModulesIntegrationsStorefrontContactRegistrationRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).registerAsync(webApiModulesIntegrationsStorefrontContactRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send email to Reset Password (for Contacts)
     * @param {WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest} [webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest?: WebApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).resetPasswordFromEmailAsync(webApiModulesIntegrationsStorefrontResetPasswordFromEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send email to Change Password (for Contacts)
     * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).sendChangePasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send an inquiry email about an item.
     * @param {WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest} [webApiModulesIntegrationsStorefrontSendInquiryEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest?: WebApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).sendInquiryEmailRequestAsync(webApiModulesIntegrationsStorefrontSendInquiryEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send email to Reset Password (for Contacts)
     * @param {WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest} [webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest?: WebApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).sendResetPasswordEmailAsync(webApiModulesIntegrationsStorefrontSendResetPasswordEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit a Quote Request
     * @param {WebApiModulesIntegrationsStorefrontQuoteRequest} [webApiModulesIntegrationsStorefrontQuoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest?: WebApiModulesIntegrationsStorefrontQuoteRequest, options?: RawAxiosRequestConfig) {
        return StorefrontApiFp(this.configuration).submitQuoteRequestAsync(webApiModulesIntegrationsStorefrontQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



